/**
 * card-add-to-cart.js
 * ------------------------------------------------------------------
 * AJAX /cart/add.js helper shared by all product cards. Pure side
 * effect module: POST to cart, refresh drawer + bubble, show toast.
 * Exposed globally as window.CardAddToCart.
 */
(function () {
  async function add(variantId, quantity = 1) {
    const body = JSON.stringify({
      id: variantId,
      quantity,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    const res = await fetch(window.Shopify?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body,
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || 'Failed to add to cart');
    }

    const parsedState = await res.json();

    // 1. Refresh cart drawer (so items, totals, empty-state all update)
    const drawerHtml = parsedState.sections?.['cart-drawer'];
    if (drawerHtml) {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const parsed = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const newDrawer = parsed.querySelector('cart-drawer');
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          cartDrawer.classList.remove('is-empty');
          if (newDrawer.classList.contains('is-empty')) {
            cartDrawer.classList.add('is-empty');
          }
          const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', () => cartDrawer.close());
          }
        }
      }
    }

    // 2. Update cart icon bubble (header count)
    const bubbleHtml = parsedState.sections?.['cart-icon-bubble'];
    if (bubbleHtml) {
      const bubbleEl = document.getElementById('cart-icon-bubble');
      if (bubbleEl) {
        const parsed = new DOMParser().parseFromString(bubbleHtml, 'text/html');
        const inner = parsed.querySelector('.shopify-section');
        bubbleEl.innerHTML = inner ? inner.innerHTML : parsed.body.innerHTML;
      }
    }

    // 3. Show the "item added" toast directly (not solely via pub/sub,
    //    so nothing else on the page can block it).
    const popup = document.querySelector('cart-notification-popup');
    if (popup && typeof popup.showForItem === 'function') {
      popup.showForItem(parsedState);
    } else {
      console.error('card-add-to-cart: cart-notification-popup element not found or not upgraded — toast not shown.', popup);
    }

    // 4. Also publish cartUpdate for everything else that listens for it.
    if (window.publish && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { cartData: parsedState });
    }

    return parsedState;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || '${{amount}}';
    const rx = /\{\{\s*(\w+)\s*\}\}/;

    const withDelimiters = (n, precision = 2, thousands = ',', decimal = '.') => {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100).toFixed(precision);
      const [dollars, fractional] = n.split('.');
      return dollars.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`) +
        (fractional ? decimal + fractional : '');
    };

    const match = fmt.match(rx);
    if (!match) return fmt;

    let val;
    switch (match[1]) {
      case 'amount_no_decimals': val = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': val = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = withDelimiters(cents, 0, '.', ','); break;
      default: val = withDelimiters(cents, 2);
    }
    return fmt.replace(rx, val);
  }

  window.CardAddToCart = { add, formatMoney };
})();
